import { breakpoints } from './breakpoints.js';
import { fontWeights } from './font-weights.js';
import { timings } from './timings.js';

/**
 * CSS style shorthands
 */

var styles = {
  breakpoint: {
    /**
     * Media query for `xs` breakpoint at 375px
     */
    xs: "@media(min-width: ".concat(breakpoints.xs, "px)"),

    /**
     * Media query for `s` breakpoint at 600px
     */
    s: "@media(min-width: ".concat(breakpoints.s, "px)"),

    /**
     * Media query for `m` breakpoint at 768px
     */
    m: "@media(min-width: ".concat(breakpoints.m, "px)"),

    /**
     * Media query for `l` breakpoint at 1024px
     */
    l: "@media(min-width: ".concat(breakpoints.l, "px)"),

    /**
     * Media query for `xl` breakpoint at 1280px
     */
    xl: "@media(min-width: ".concat(breakpoints.xl, "px)"),

    /**
     * Media query for `xxl` breakpoint at 1440px
     */
    xxl: "@media(min-width: ".concat(breakpoints.xxl, "px)")
  },
  breakpointMax: {
    /**
     * Media query for `xs` breakpoint at 375px
     */
    xs: "@media(max-width: ".concat(breakpoints.xs - 1, "px)"),

    /**
     * Media query for `s` breakpoint at 600px
     */
    s: "@media(max-width: ".concat(breakpoints.s - 1, "px)"),

    /**
     * Media query for `m` breakpoint at 768px
     */
    m: "@media(max-width: ".concat(breakpoints.m - 1, "px)"),

    /**
     * Media query for `l` breakpoint at 1024px
     */
    l: "@media(max-width: ".concat(breakpoints.l - 1, "px)"),

    /**
     * Media query for `xl` breakpoint at 1280px
     */
    xl: "@media(max-width: ".concat(breakpoints.xl - 1, "px)"),

    /**
     * Media query for `xxl` breakpoint at 1440px
     */
    xxl: "@media(max-width: ".concat(breakpoints.xxl - 1, "px)")
  },
  fontFamily: {
    /**
     * Base font family: FortumSans
     */
    base: 'FortumSans, arial, sans-serif'
  },
  fontSize: {
    /**
     * Base font size: 16px
     */
    base: 16
  },

  /**
   * Font-weights
   */
  fontWeight: fontWeights,
  transition: {
    timing: {
      /**
       * `slowest` timing: 300ms
       */
      slowest: "".concat(timings.slowest, "ms"),

      /**
       * `slower` timing: 250ms
       */
      slower: "".concat(timings.slower, "ms"),

      /**
       * `base` timing: 200ms
       */
      base: "".concat(timings.base, "ms"),

      /**
       * `faster` timing: 150ms
       */
      faster: "".concat(timings.faster, "ms"),

      /**
       * `fastest` timing: 100ms
       */
      fastest: "".concat(timings.fastest, "ms"),

      /**
       * `extraFast` timing: 50ms
       */
      extraFast: "".concat(timings.extraFast, "ms")
    },
    "function": {
      /**
       * elemental-ui's base CSS transition function
       */
      base: 'cubic-bezier(0.5, 0, 0, 1)'
    }
  }
};

export { styles };
